import loadable from '@loadable/component';

export const LoadableHealthOverAttemptWidget = loadable(() => import('./healthOverAttempt'));
